import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Sidebar } from '../components/Sidebar';
export function MainLayout() {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-124">
      <Navbar data-id="element-125" />
      <div className="flex flex-1" data-id="element-126">
        <Sidebar data-id="element-127" />
        <main className="flex-1 p-6" data-id="element-128">
          <Outlet data-id="element-129" />
        </main>
      </div>
      <Footer data-id="element-130" />
    </div>;
}